import useSWR from "swr";
import { type QuizSummary } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/quizzes";

/** Every quiz in the active group, with invited/completed counts (managers only). */
export function useQuizzes() {
  return useSWR<QuizSummary[], Error>(url, simpleFetcher, {
    // Poll while any quiz is still generating so its row turns into a real quiz
    // on its own; stop once they are all ready.
    refreshInterval: (quizzes) =>
      quizzes?.some((quiz) => quiz.status === "generating") ? 3000 : 0,
  });
}
